import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/@core/services/notification.service';
import { ProgressBarService } from 'src/@core/services/progress-bar.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatPaginator,
  MatSort,
} from '@angular/material';
import { BehaviorSubject, Subscription, merge, of as observableOf } from 'rxjs';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { Search } from 'src/@core/interfaces/search';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { JobService } from 'src/@core/services/job/job.service';
import { AppService, CURRENT_USER } from 'src/@core/services/app.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions'
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { NavigationExtras, Router } from '@angular/router';
import { LocalStorageService } from 'src/@core/services/local-storage.service';
import { STATUS } from 'src/app/shared/helpers/status';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GET_PO, GET_QUOTATION } from 'src/@core/services/util/api.endpoints';
import { CreatePurchaseOrderComponent } from '../create-purchase-order/create-purchase-order.component';

@Component({
  selector: 'hour4u-admin-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrls: ['./purchase-order-list.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ]
})
export class PurchaseOrderListComponent implements OnInit {
  dataChange: BehaviorSubject<any>;
  @Input() data?: any;
  @Input() vendorView?: boolean = false;
  roles = roles;
  permissions = permissions;
  entityTypes = entityTypes;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  resultsLength = 0;
  title = 'Job';
  columns = [
    // { columnDef: 'checkbox', visible: true, label: 'Checkbox' },
    { columnDef: 'poId', visible: true, label: 'PO ID' },
    { columnDef: 'agencyName', visible: true, label: 'Agency Name' },
    { columnDef: 'status', visible: true, label: 'Status' },
    { columnDef: 'finalAmount', visible: true, label: 'Final Amount' },
    { columnDef: 'paymentTerms', visible: true, label: 'Payment Terms' },
    { columnDef: 'validity', visible: true, label: 'Validity' },
    { columnDef: 'action', visible: true, label: 'Action' },
  ];
  displayedColumns = this.columns.map(x => x.columnDef);
  profile = this.appService.getCurrentAccount();
  pageSize = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  prevUrl: String;
  searchParams: Array<Search> = [];
  row: any;
  sort_field: string = '';
  diameter = 40;
  color: string;
  mode = 'indeterminate';
  status = STATUS;
  selectedAgency: any = null;
  selectedCreatedOn: any = null;
  selectedCreatedBy: any = null;
  selectedExpiredBy: any = null;
  agenciesList: any[] = [];
  createdByList: any[] = [];
  selection = new SelectionModel<any>(true, []);
  allRowsSelected: boolean = false;
  isLoading: boolean = false;
  poList: any[] = [];
  screenWidth = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }
  arrayPOs: any[] = [];
  subscrier: Subscription;

  constructor(private dialog: MatDialog,
    private service: JobService,
    private jobTypeService: JobTypeService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private notify: NotificationService,
    private progress: ProgressBarService,
    private appService: AppService,
    private _localStorageService: LocalStorageService,
    private http: HttpClient) {

    this.subscrier = this.service.getRefreshPOPage().subscribe(res => {
      this.getPOData();
    });
  }

  ngOnInit() {
    this.dataChange = new BehaviorSubject(0);
    if (this.data) {
      this.getPOData();
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  getPOData() {
    this.isLoading = true;
    const sort = 'createdOn,desc';
    this.poList = [];
    const httpParams = new HttpParams()
      .set('sort', sort)
      .set('jobId', this.data.id.toString())
      .set('vendorView', this.vendorView.toString())
    // .set('size', this.pageSize.toString())

    this.http.get<any>(GET_PO, { params: httpParams }).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && Array.isArray(response)) {
          if (response && response.length) {
            response.forEach(element => {
              console.log(element)
              element.totalCost = 0;
              if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
                if (element.jobRateCards && element.jobRateCards.length) {
                  element.jobRateCards.forEach(ele => {
                    element.totalCost = element.totalCost + ele.totalAmount;
                  });
                }
              }

              if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
                if (element.variableJobRateCards && element.variableJobRateCards.length) {
                  element.variableJobRateCards.forEach(ele => {
                    element.totalCost = element.totalCost + ele.totalAmount;
                  });
                }
              }
              element.totalCost = element.totalCost * 1.18;
            });
          }
          this.poList = response;
          this.resultsLength = this.poList.length;
          this.selection.clear();
          this.poList.forEach(row => this.selection.select(row));
          if (this.data && this.data.billingType == 'NONE') {
            this.columns = this.columns.map(x => {
              x.visible = true;
              if (x.columnDef === 'finalAmount' || x.columnDef === 'paymentTerms')
                x.visible = false;
              return x;
            });
            this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
          }
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch bookings:', error);
      }
    );
  }

  reloadTable() {
    // this.dataChange.next(1);
  }

  sortData(direction) {
    this.sort.active = 'createdOn';
    this.sort.direction = direction.value;
    this.sort.sortChange.next();
  }

  dataRefresh() {
    this.ngOnInit();
  }

  // create PO
  createPO() {
    console.log("##############", this.data)
    // if (this.data && this.data.quotationRequired) {
    //   this.data.withQuote = true;
    // } else {
    this.data.withQuote = false;
    // }
    this.data.action = "Create";
    this.data.poList = this.poList;
    const dialogRef = this.dialog.open(CreatePurchaseOrderComponent, {
      width: '900px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: this.data,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getPOData();
      }
    });
  }

  // edit Field
  editPO(row) {
    let data = Object.assign({}, this.data);
    data.poDetails = row;
    data.action = "Edit";

    const dialogRef = this.dialog.open(CreatePurchaseOrderComponent, {
      width: '900px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: data,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getPOData();
      }
    });
  }

  // accept Reject PO
  acceptRejectPO(data, status) {
    this.service.updatePOStatus(data.id, status).subscribe(res => {
      this.dataRefreshIndividualRow(res);
      this.notify.showMessage('Quotation Status Updated Successfully!', 2000);
    }, ((err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    }))
  }

  // refresh individual row
  dataRefreshIndividualRow(res) {
    this.poList.forEach((ele: any, index) => {
      if (ele.id == res.id) {
        ele.totalCost = 0;
        if (this.data && this.data.billingType.includes('FIXED')) {
          if (ele.jobRateCards && ele.jobRateCards.length) {
            ele.jobRateCards.forEach(ele1 => {
              ele.totalCost = ele.totalCost + ele1.totalAmount;
            });
          }
        }
        if (this.data && this.data.billingType.includes('VARIABLE')) {
          if (ele.variableJobRateCards && ele.variableJobRateCards.length) {
            ele.variableJobRateCards.forEach(ele1 => {
              ele.totalCost = ele.totalCost + ele1.totalAmount;
            });
          }
        }
        ele.totalCost = ele.totalCost * 1.18;
        res.totalCost = ele.totalCost;
        this.poList[index] = res;
        this.poList = [...this.poList];
        // if (this.isAllSelected()) {
        this.selection.clear();
        this.poList.forEach(row => this.selection.select(row));
        // }
        console.log(this.poList)
        this.cdRef.detectChanges();
      }
    })
  }

  // Select all rows 
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.poList.length;
    this.arrayPOs = [];
    let data: any = Object.assign({}, this.selection);
    if (data._selected && data._selected.length) {
      data._selected.forEach(element => {
        this.poList.forEach(el => {
          if (element.id == el.id) {
            this.arrayPOs.push(el)
          }
        })
      });
    }
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.poList.forEach(row => this.selection.select(row));
    this.isAllSelected() ? this.allRowsSelected = true : this.allRowsSelected = false;
  }

  createWorkOrder() {
    const navigationExtras: NavigationExtras = {
      queryParams: { 'jobId': this.data.id, 'jobTypeId': this.data.jobTypeId, 'employerId': this.data.employerId }
    }
    this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  }


  viewPo(row) {
    this.router.navigateByUrl('/job/purchase-order/' + row.id);
  }

  ngOnDestroy() {
    this.subscrier.unsubscribe();
  }
}
